import axios from '../config/axiosPrivate';

export const getApartmentTypes = async (params: any) => {
  const url = `/settings/apartment-types`;
  const response = await axios.get(url, { params });
  return response.data;
};

export const getCompanyPreferences = async (params: any = {}) => {
  const url = `/company/preferences`;
  const response = await axios.get(url, { params });
  return response.data;
};

export const updateCompanyPreferences = async (companyId: number, payload: { incentive_scrapping: boolean }) => {
  const url = `/company/preferences/${companyId}`;
  const response = await axios.patch(url, payload);
  return response.data;
};

export const bulkUpdateCompanyPreferences = async (payload: { company: number; incentive_scrapping: boolean }[]) => {
  const url = `/company/preferences/bulk`;
  const response = await axios.post(url, payload);
  return response.data;
};
